var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6C12.0561 6 6 12.0561 6 19.5C6 26.9439 12.0561 33 19.5 33C26.9439 33 33 26.9439 33 19.5C33 12.0561 26.9439 6 19.5 6ZM23.9456 25.8545L18.15 20.0589V11.4H20.85V18.9411L25.8545 23.9456L23.9456 25.8545Z",
    fill: "#007BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b5db5edb8a9d8d454ab59d2cba629327.svg";
export { ForwardRef as ReactComponent };